<template>
  <div class="login-page">
    <h2>Вход</h2>
    <form v-loading="request.state.pending" @submit.prevent="handleSubmit">
      <form-item :error="request.state.errors.username">
        <custom-input v-model="form.username" label="Имя пользователя" />
      </form-item>
      <form-item :error="request.state.errors.password">
        <custom-input v-model="form.password" type="password" label="Пароль" />
      </form-item>
      <button class="button" type="submit">Войти</button>
    </form>
  </div>
</template>

<script lang="ts" setup>
import { reactive } from 'vue'
import { iRequestLogin } from '@/types/requests'
import useFormRequest from '@/composables/useFormRequest'
import { login } from '@/api/auth'
import store from '@/store'
import FormItem from '@/components/common/FormItem.vue'
import { loadRegions } from '@/api/regions'

const form = reactive<iRequestLogin>({
  username: '',
  password: ''
})

const request = useFormRequest<iRequestLogin>()

const handleSubmit = () => {
  request.tryRequest(async () => {
    const response = await login(form)
    store.login(response.data)

    store.setCurrentRegion(undefined)

    const regionsResponse = await loadRegions()
    store.setRegions(regionsResponse.data)
  })
}

</script>

<style>
.login-page {
  max-width: 300px;
  margin: auto;
  padding: 100px 20px 0;
}
</style>
